export default {
  shownFacets: {
    hardwareListingPage: {
      operatingSystems: true,
      manufacturers: true,
      colors: true,
      storage: true,
      priceRange: true,
      displayRange: true,
      accessories: true,
    },
    tariffListingPage: {
      carriers: true,
      priceRange: true,
      volumeRange: true,
      speedRange: true,
      additionalOptions: false,
      contractTerms: true,
    },
    hardwarePDP: {
      carriers: true,
      priceRange: true,
      oneTimePriceFromRange: true,
      volumeRange: true,
      speedRange: true,
      additionalOptions: false,
      contractTerms: true,
    },
    tariffPDP: {
      operatingSystems: true,
      manufacturers: true,
      colors: true,
      storage: true,
      priceRange: true,
      displayRange: true,
    },
    // Landingpages facets will be set in ACP
  },
};
